import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import useLiveData from 'hooks/useLiveData';
import Gallery from 'components/Gallery';

const SmartGalleryProvider = (props) => {
	const data = useStaticQuery(graphql`
		query AllSmartGalleries {
			allSmartTagsGallery {
				edges {
					node {
						id
						image
						content
						layout
						mobileLayout
						fullWidth
					}
				}
			}
		}
	`);
	const { response } = useLiveData({
		namespace: 'SmartTags',
		model: 'Gallery',
		method: 'all',
		graphqlKey: 'allSmartTagsGallery',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
		},
		staticData: data,
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <Gallery gallery={attr} />;
};

export default SmartGalleryProvider;